export default __webpack_public_path__ + "497a1ffde7709f2115d09dae07405692.png";